import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { OrganisationsService } from "../../services/organisationsService";

// create slice

const name = "organisations";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();

const slice = createSlice({
  name,
  initialState,
  reducers,
  ...extraReducers,
});

// exports

export const orgActions = { ...slice.actions, ...extraActions };
export const orgReducer = slice.reducer;

// implementation

function createInitialState() {
  return {};
}

function createReducers() {
  return {
    setOrganisations,
  };

  function setOrganisations(state, action) {
    // Redux Toolkit allows us to write "mutating" logic in reducers. It
    // doesn't actually mutate the state because it uses the Immer library,
    // which detects changes to a "draft state" and produces a brand new
    // immutable state based off those changes
    state.payload = action.payload;
  }
}

function createExtraActions() {
  return {};
}

export const getOrganisations = createAsyncThunk(
  "organisations/get",
  async (id, thunkAPI) => {
    try {
      let response = await OrganisationsService.getAllOrganisations();

      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

function createExtraReducers() {
  return {
    extraReducers: (builder) => {
      builder
        .addCase(getOrganisations.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(getOrganisations.fulfilled, (state, action) => {
          state.isLoading = false;
          state.isSuccess = true;
          state.payload = action.payload;
        })
        .addCase(getOrganisations.rejected, (state, action) => {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload;
        });
    },
  };
}
